module.exports = __webpack_public_path__ + "img/icon_download.5ccbe50f.svg";